module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "id": "epig_1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep1"
  }, [_vm._v("A man’s greatest strength can likewise be his greatest weakness.")]), _vm._v(" "), _c('p', {
    staticClass: "eps"
  }, [_vm._v("—Origin Unknown")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3497986","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KingofStorms_epig_1.vue
// module id = 75
// module chunks = 0